/**
 * Configuration constants for ParallaxFooter behavior
 */

/**
 * Maximum distance from bottom (in pixels) where footer starts to appear.
 * The actual reveal boundary is min(this value, half of scrollable height).
 */
export const ABSOLUTE_START_DISTANCE = 400;

/** Delay (in milliseconds) before revealing footer on non-scrollable pages after user interaction */
export const NON_SCROLLABLE_REVEAL_DELAY = 1000;
